import api from "./api.config";
const stats = (params) => {
    
    return api
        .get(`/api/admin/reports/stats`, {
            params
        })
        .then((response) => {
            return response.data;
        });
}
const payments = (params) => {
    
    return api
        .get(`/api/admin/reports/payments`, {
            params
        })
        .then((response) => {
            return response.data;
        });
}
const dashboardCounter = () => {
    
    return api
        .get(`/api/admin/reports/dashboard/counter`)
        .then((response) => {
            return response.data;
        });
}
const monitor = (params) => {
    
    return api
        .get(`/api/admin/reports/monitor`, {
            params
        })
        .then((response) => {
            return response.data;
        });
}
const ReportsService = {
    stats,
    monitor,
    payments,
    dashboardCounter
};

export default ReportsService;